import { APIConfig } from 'src/config';
import axiosClient from '../utils/axios-client';

class CouponApi {
  private userManagementApiUrl = APIConfig.userManagementApiUrl;

  // get all coupons
  async getAllCoupons():
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.userManagementApiUrl}coupon/all`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.error(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const couponApi = new CouponApi();
